<template>
  <v-card>
    <v-card-text>
      <slot />
    </v-card-text>
  </v-card>
</template>

<script>
export default {}
</script>